import React from "react";
import { ReelMetadata } from "../../types";

interface OceanHeaderProps {
  data: ReelMetadata;
  opacity: number;
  scale: number;
  translateY: number;
}

export const OceanHeader: React.FC<OceanHeaderProps> = ({
  data,
  opacity,
  scale,
  translateY,
}) => {
  return (
    <div
      style={{
        width: "100%",
        opacity,
        transform: `scale(${scale}) translateY(${translateY}px)`,
      }}
    >
      <div
        style={{
          background: "rgba(1,13,26,0.85)",
          border: "1px solid rgba(0,212,255,0.3)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          padding: "20px 28px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Label */}
        <div
          style={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: "10px",
            color: "#00d4ff",
            letterSpacing: "5px",
            textTransform: "uppercase",
            fontWeight: 600,
          }}
        >
          DEEP OCEAN INTELLIGENCE
        </div>

        {/* Headline */}
        <h2
          style={{
            fontFamily: "'Source Serif 4', serif",
            fontSize: "28px",
            fontWeight: 600,
            color: "#e8f8ff",
            lineHeight: 1.35,
            margin: 0,
            letterSpacing: "-0.3px",
          }}
        >
          {data.headline}
        </h2>

        {/* Wavy decoration: a horizontal bar with border-radius simulating a wave */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "6px",
            marginTop: "4px",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: "50%",
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, rgba(0,212,255,0.6) 20%, rgba(127,255,212,0.5) 50%, rgba(0,212,255,0.6) 80%, transparent)",
              borderRadius: "50%",
              transform: "translateY(-50%)",
            }}
          />
          {/* Second wave offset for depth */}
          <div
            style={{
              position: "absolute",
              left: "10%",
              right: "10%",
              bottom: 0,
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, rgba(0,212,255,0.3) 30%, rgba(0,212,255,0.3) 70%, transparent)",
              borderRadius: "50%",
            }}
          />
        </div>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
